// core/error/notification.service.ts
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private snack = inject(MatSnackBar);

  public info(msg: string, duration: number = 4000): void {
    if (!msg || msg == '') return;

    this.snack.open(msg, 'x', {
      duration,
      panelClass: 'snackbar-class-success',
    });
  }

  public warn(msg: string, duration: number = 4000): void {
    if (!msg || msg == '') return;

    this.snack.open(msg, 'x', {
      duration,
      panelClass: 'snackbar-class-warning',
    });
  }

  public error(msg?: string, duration: number = 3000): void {
    if (!msg || msg == '') msg = 'Something went wrong!';

    this.snack.open(msg, 'x', {
      duration,
      panelClass: 'snackbar-class-error',
    });
  }
}
